import React from 'react';
import {AsyncComponent} from "../../../../../core/components/router/async-component";

const LiveMatchTrackerModuleAsyncComponent = AsyncComponent(async () => import('./live-match-tracker-module' /* webpackChunkName: "live-match-tracker-module" */ ));

export const LiveMatchTrackerModuleAsync = (props) => {
  return <React.Suspense fallback={<div />}>
    <LiveMatchTrackerModuleAsyncComponent {...props}/>
  </React.Suspense>
};
